/**
 * Created by bob.gear on 25/05/2017.
 */
angular.module("SummaryDownload", ["EICDataStream3.config"])
  .service('summaryDownloadService',
  [
    '$http',
    function($http) {
      var service = this;
     
      var download = function (data, filename) {
        const blob = new Blob([data], { type: 'type: "octet/stream' });
  
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
  
        link.click();
  
      };

      var downloadSummary = function (url) {
        $http.get(url, { responseType: 'blob', observe: 'response' })
          .then((resp) => {
            const contentDisposition = resp.headers()['content-disposition'];
            const filenameHeader = contentDisposition.split(";")[1];
            const filename = filenameHeader.split("=")[1];
  
            download(resp.data, filename);
          },
            error => {
              console.log('Error downloading the file.', error)
            });
      };

      service.projectSearch = function(guid) {
        var path = "/api/summaryexport/projectsearch/{guid}"
          .replace("{guid}", guid);

        return downloadSummary(path);
      };

      service.contractAwardSearch = function(guid) {
        var path = "/api/summaryexport/contractawardsearch/{guid}"
          .replace("{guid}", guid);

        return downloadSummary(path);
      };

      service.recentlyAddedProjects = function(createdWithinWeeks) {
        var path = "/api/summaryexport/?createdWithinWeeks={createdWithinWeeks}"
          .replace("{createdWithinWeeks}", createdWithinWeeks);

        return downloadSummary(path);
      };

      service.projectWatch = function(guid) {
        var path = "/api/summaryexport/projectnotification/{guid}"
          .replace("{guid}", guid);

        return downloadSummary(path);
      };

      service.pdfReport = function(guid) {
        var path = "/api/summaryexport/pdfReport/{guid}"
          .replace("{guid}", guid);

        return downloadSummary(path);
      };
    }
  ]);